import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getEmailTemplategetSlice = createSlice({
    name: 'EmailTemplateget',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchEmailTemplateget.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchEmailTemplateget.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchEmailTemplateget.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setEmailTemplateget , setStatus} = getEmailTemplategetSlice.actions;
export default getEmailTemplategetSlice.reducer;

export const fetchEmailTemplateget = createAsyncThunk('/EmailTemplategetget/fetch', async() => {
    const res = await axios.get(`${window.env.API_URL}/EmailTemplateget`);
    const EmailTemplategetData = res.data;
    return EmailTemplategetData.data;
})